import React from 'react';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';
import {
    Calendar,
    Category,
    ReportToggle,
    Competition,
    Performance,
} from './components';
import Dashboard from '../Dashboard'
import {getCategory} from '../../apis/api';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
    dashboard: {
        margin: -theme.spacing(1),
    }
}));

const Error = () => (<div>Error</div>);

const Monthly = () => {
    const classes = useStyles();
    const [report, setReport] = React.useState('dashboard');
    const [options, setOptions] = React.useState({});
    const TERM = 'monthly';
    const getStandardDate = () => {
        const standard_date = new Date();
        standard_date.setMonth(standard_date.getMonth() - 1);

        return standard_date;
    };
    const getComparisonDate = () => {
        const comparison_date = new Date();
        comparison_date.setMonth(comparison_date.getMonth() - 2);

        return comparison_date;
    };
    const onChange = (reportType) => {
        setReport(reportType);
        setOptions({report: ''});
    };
    // eslint-disable-next-line react/no-multi-comp
    const reportComponent = (options) => {
        switch (options.report) {
            case 'dashboard': return <div className={classes.dashboard}><Dashboard term={TERM} options={options} /></div>;
            case 'performance': return <Performance term={TERM} options={options} />;
            case 'competition': return <Competition term={TERM} options={options} />;
            default: return null;
        }
    };

    // 카테고리 선택
    const [category, setCategory] = React.useState({});
    const changeCategory = (cate = {}) => {
        setCategory(cate);
    };

    // 대카테고리 리스트 가져오기
    const [categoryList, setCategoryList] = React.useState([]);
    if (categoryList.length === 0) {
        getCategory()
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setCategoryList(res);
            }).catch(() => {
                return errorHandler();
            });
    }

    const onSubmit = ({targetDate, compareDate}) => {
        const {parentCode: category1, code: category2} = category;

        if (category1 && targetDate && compareDate) {
            setOptions({
                report,
                category1,
                ...(category2 !== '' ? {category2} : {}),
                targetDate,
                compareDate
            });
        }
    };
    const errorHandler = () => <Error />;

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <ReportToggle
                        onChange={onChange}
                        term={TERM}
                    />
                </Grid>
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={12}
                >
                    <Category
                        categoryList={categoryList}
                        changeCategory={changeCategory}
                    />
                </Grid>
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={6}
                    xs={12}
                >
                    <Calendar
                        comparison_date_option={{
                            format: 'yyyy/MM',
                            label: 'comparison month',
                            openTo: 'year',
                            views: ['year', 'month'],
                            date: getComparisonDate(),
                        }}
                        start_date_option={{
                            format: 'yyyy/MM',
                            label: 'reference month',
                            openTo: 'year',
                            views: ['year', 'month'],
                            date: getStandardDate()
                        }}
                        term={TERM}
                        onSubmit={onSubmit}
                    />
                </Grid>
                {reportComponent(options)}
            </Grid>
        </div>
    );
};

export default Monthly;
